import DonorSimulationAvatar from '/images/donor-simulation-avatar.png';
import card from '/images/card.png';
import card2 from '/images/card2.png';
import card3 from '/images/card3.png';
import ConfusedFace from '/images/confused-face.gif';
import NeutralFace from '/images/neutral-face.gif';
import SmilingFace from '/images/smiling-face.gif';
import HuggingFace from '/images/hugging-face.gif';
import StarFace from '/images/star-face.gif';
import goal from '@/svgs/goal.svg';
import chatbot from '@/svgs/chatbot.svg';
import scenarios from '@/svgs/scenarios.svg';
import aiEmailAssistant from '@/svgs/email.svg';
import { DonorTypesEnum, GendersEnum } from '@/types/donor';

// Donor Types as an array
export const donorTypes = [
  { label: 'Individual Donor', value: DonorTypesEnum.INDIVIDUAL_DONOR },
  { label: 'Corporate Partner', value: DonorTypesEnum.CORPORATE_PARTNER },
  { label: 'Foundation Funder', value: DonorTypesEnum.FOUNDATION_FUNDER }
];

// Relationship  as an array
export const donorRelationship = [
  { key: 'First Meeting', value: 'First Meeting' },
  { key: 'Engaged', value: 'Engaged' },
  { key: 'Committed Supporter', value: 'Committed Supporter' },
  { key: 'Major Donor', value: 'Major Donor' },
  { key: 'Lapsed Donor', value: 'Lapsed Donor' },
  { key: 'Advocate/Champion', value: 'Advocate/Champion' },
  { key: 'Volunteer', value: 'Volunteer' },
  { key: 'Legacy/Planned Giving Donor', value: 'Legacy/Planned Giving Donor' }
];

export const relationIndividual = [
  { label: 'Initial Engagement', value: 'Initial Engagement' },
  { label: 'Engaged', value: 'Engaged' },
  { label: 'Committed Supporter', value: 'Committed Supporter' },
  { label: 'Major Donor', value: 'Major Donor' },
  { label: 'Lapsed Donor', value: 'Lapsed Donor' },
  { label: 'Advocate/Champion', value: 'Advocate/Champion' },
  { label: 'Volunteer', value: 'Volunteer' },
  { label: 'Legacy/Planned Giving Donor', value: 'Legacy/Planned Giving Donor' },
  { label: 'Board Member', value: 'Board Member' },
  { label: 'Event Attendee', value: 'Event Attendee' },
  { label: 'Event Host', value: 'Event Host' },
  { label: 'Grateful Patient', value: 'Grateful Patient' },
  { label: 'Alumni', value: 'Alumni' }
];

// Donor Types as an array
export const practiceTypes = [
  {
    key: 'Specific Funder Meeting Preparation',
    value: 'Specific Funder Meeting Preparation'
  },
  { key: 'General Practice', value: 'General Practice' }
];

export const donorHistory = [
  {
    label: 'A first-time financial donor',
    value: 'A first-time financial donor'
  },
  { label: 'A repeat financial donor', value: 'A repeat financial donor' },
  {
    label: 'Have not given financially but have donated time or talent',
    value: 'Have not given financially but have donated time or talent'
  },
  {
    label: 'Have not donated or given in any way',
    value: 'Have not donated or given in any way'
  }
];

export const donorMotivation = [
  {
    label: 'Personal Connection: Driven by emotions and experiences',
    value: 'Personal Connection: Driven by emotions and experiences'
  },
  {
    label: 'Social Responsibility: Driven by a sense of duty to society',
    value: 'Social Responsibility: Driven by a sense of duty to society'
  },
  {
    label: 'Strategic Impact: Driven by measurable results and effectiveness',
    value: 'Strategic Impact: Driven by measurable results and effectiveness'
  },
  {
    label: 'Recognition/Legacy: Driven by acknowledgment and a desire for long-term remembrance',
    value: 'Recognition/Legacy: Driven by acknowledgment and a desire for long-term remembrance.'
  }
];

// Donor Types as an array
// donorGoals
export const goalsIndividual = [
  { key: 'Introduce the Organization', value: ' Introduce the Organization' },
  { key: 'Introduce Myself', value: ' Introduce Myself' },
  {
    key: 'Solicit for Capital Campaign',
    value: 'Solicit for Capital Campaign'
  },
  {
    key: 'Ask to Join the Board',
    value: 'Ask to Join the Board'
  },
  {
    key: 'Build or Strengthen Engagement',
    value: 'Build or Strengthen Engagement'
  },
  {
    key: 'Secure a Pledge or Commitment',
    value: ' Secure a Pledge or Commitment'
  },
  {
    key: 'Express Gratitude and Provide Impact Updates',
    value: 'Express Gratitude and Provide Impact Updates'
  },
  {
    key: 'Discuss Planned Giving or Legacy Opportunities',
    value: 'Discuss Planned Giving or Legacy Opportunities'
  },

  {
    key: 'Invite to Event or Further Involvement',
    value: 'Invite to Event or Further Involvement'
  },
  { key: 'Re-engage a Lapsed Donor', value: 'Re-engage a Lapsed Donor' },
  { key: 'Gain Feedback or Input', value: 'Gain Feedback or Input' },

  {
    key: 'Transition to Advocacy/Leadership Role',
    value: ' Transition to Advocacy/Leadership Role'
  },
  { key: 'Retention', value: 'Retention' }
];

export const goalsCorporate = [
  { key: 'Introduce Myself', value: ' Introduce Myself' },
  {
    key: 'Explore Potential Alignment and Partnership Opportunities',
    value: 'Explore Potential Alignment and Partnership Opportunities'
  },
  {
    key: 'Develop and Refine a Proposal for Collaboration',
    value: 'Develop and Refine a Proposal for Collaboration'
  },
  {
    key: 'Strengthen an Existing Partnership',
    value: ' Strengthen an Existing Partnership'
  },
  {
    key: 'Discuss Sponsorship for an Upcoming Event or Campaign',
    value: 'Discuss Sponsorship for an Upcoming Event or Campaign'
  },
  {
    key: 'Secure Funding or In-Kind Support for a Specific Project',
    value: 'Secure Funding or In-Kind Support for a Specific Project'
  },

  {
    key: 'Express Gratitude and Provide Impact Updates',
    value: 'Express Gratitude and Provide Impact Updates'
  },
  { key: 'Re-engage a Lapsed Partner', value: 'Re-engage a Lapsed Partner' },
  {
    key: 'Discuss Strategic Long-Term Partnership',
    value: 'Discuss Strategic Long-Term Partnership'
  },

  {
    key: 'Invite to Participate in a Leadership or Advocacy Role',
    value: ' Invite to Participate in a Leadership or Advocacy Role'
  },

  {
    key: 'Employee Engagement or Volunteerism',
    value: ' Employee Engagement or Volunteerism'
  },

  {
    key: 'Gain Feedback or Input on Current Initiatives',
    value: ' Gain Feedback or Input on Current Initiatives'
  },
  { key: 'Retention', value: 'Retention' }
];

export const goalsFoundations = [
  { key: 'Introduce the Organization', value: 'Introduce the Organization' },
  { key: 'Introduce Myself', value: ' Introduce Myself' },
  { key: 'Build or Deepen Engagement', value: 'Build or Deepen Engagement' },
  {
    key: 'Secure a Pledge  Commitment or Invitation to Apply for Funding',
    value: ' Secure a Pledge Commitment or Invitation to Apply for Funding'
  },
  {
    key: 'Express Gratitude and Provide Impact Updates',
    value: 'Express Gratitude and Provide Impact Updates'
  },
  {
    key: 'Invite to Event or Further Involvement',
    value: 'Invite to Event or Further Involvement'
  },

  {
    key: 'Re-engage the Foundation',
    value: 'Re-engage the Foundation'
  },
  { key: 'Gain Feedback or Input', value: 'Gain Feedback or Input' },
  { key: 'Retention', value: 'Retention' }
];

export const departmentInterest = [
  {
    label: 'Corporate Social Responsibility (CSR) grantmaking efforts',
    value: ' Corporate Social Responsibility (CSR) grantmaking efforts'
  },
  {
    label: 'Enhancing brand visibility and reputation',
    value: 'Enhancing brand visibility and reputation'
  },
  {
    label: 'Employee involvement and engagement',
    value: 'Employee involvement and engagement'
  },

  {
    label: 'Product or service synergy (lead acquisition, bottom-line impact)',
    value: ' Product or service synergy (lead acquisition, bottom-line impact)'
  }
];

export const previousEngageMent = [
  {
    label: 'They have previously sponsored',
    value: ' They have previously sponsored'
  },
  {
    label: 'They have previously been involved in employee giving',
    value: 'They have previously been involved in employee giving'
  },
  {
    label: 'They have previously been involved in volunteerism',
    value: 'They have previously been involved in volunteerism'
  },

  {
    label: 'They have previously been involved in another capacity',
    value: ' They have previously been involved in another capacity'
  },
  {
    label: 'They haven’t previously been involved at all',
    value: ' They haven’t previously been involved at all'
  }
];

export const corporateRelation = [
  {
    label: 'Prospective Partner',
    value: ' Prospective Partner'
  },
  {
    label: 'Interested Partner',
    value: 'Interested Partner'
  },
  {
    label: 'Committed Partner',
    value: 'Committed Partner'
  },

  {
    label: 'Long-Term Strategic Partner',
    value: ' Long-Term Strategic Partner'
  },
  {
    label: 'Lapsed Partner',
    value: ' Lapsed Partner'
  }
];

export const decisionMarker = [
  {
    key: 'Corporate Social Responsibility Team',
    value: ' Corporate Social Responsibility Team'
  },
  {
    key: 'Marketing Team',
    value: 'Marketing Team'
  },
  {
    key: 'Human Resources Department',
    value: 'Human Resources Department'
  },

  {
    key: 'Executive Leadership',
    value: ' Executive Leadership'
  },
  {
    key: 'Corporate Philanthropy Department',
    value: ' Corporate Philanthropy Department'
  }
];

export const founderFocusArea = [
  {
    label: 'Education',
    value: ' Education'
  },
  {
    label: 'Health & Wellness',
    value: 'Health & Wellness'
  },
  {
    label: 'Environment & Conservation',
    value: 'Environment & Conservation'
  },

  {
    label: 'Arts & Culture',
    value: ' Arts & Culture'
  },
  {
    label: 'Social Justice & Human Rights',
    value: ' Social Justice & Human Rights'
  },

  {
    label: 'Economic Development',
    value: ' Economic Development'
  },
  {
    label: 'Community & Civic Engagement',
    value: 'Community & Civic Engagement'
  },
  {
    label: 'Science & Technology',
    value: 'Science & Technology'
  },

  {
    label: 'Youth Development',
    value: ' Youth Development'
  },
  {
    label: 'International Development',
    value: ' International Development'
  },

  {
    label: 'Disaster Relief & Humanitarian Aid',
    value: ' Disaster Relief & Humanitarian Aid'
  },
  {
    label: 'Housing & Homelessness',
    value: ' Housing & Homelessness'
  }
];

export const foundationRelation = [
  {
    label: 'Prospective Funder',
    value: ' Prospective Funder'
  },
  {
    label: 'In Contact/Initial Interest',
    value: 'In Contact/Initial Interest'
  },
  {
    label: 'Application Submitted',
    value: 'Application Submitted'
  },

  {
    label: 'Current Active Funder',
    value: ' Current Active Funder'
  },
  {
    label: 'Long-Term or Multiple Project Funder',
    value: ' Long-Term or Multiple Project Funder'
  },
  {
    label: 'Lapsed Funder',
    value: 'Lapsed Funder'
  }
];

export const grantCycleStatus = [
  {
    label: 'Open for Applications',
    value: ' Open for Applications'
  },
  {
    label: 'In Review',
    value: 'In Review'
  },
  {
    label: 'Closed',
    value: 'Closed'
  },

  {
    label: 'By Invitation Only',
    value: ' By Invitation Only'
  }
];

export const fundingPreference = [
  {
    label: 'Pilot Projects',
    value: ' Pilot Projects'
  },
  {
    label: 'Launch of New Programs',
    value: 'Launch of New Programs'
  },
  {
    label: 'Sustaining Existing Programs',
    value: 'Sustaining Existing Programs'
  }
];

export const impactMetricPreference = [
  {
    label: 'Quantitative Outcomes',
    value: ' Quantitative Outcomes'
  },
  {
    label: 'Qualitative Stories',
    value: 'Qualitative Stories'
  },
  {
    label: 'Long-term Change',
    value: 'Long-term Change'
  },

  {
    label: 'Immediate Impact',
    value: ' Immediate Impact'
  }
];

export const meetingsArray = [
  {
    title: 'Funder Meeting Preparation',
    donorType: 'Corporate Partner',
    practiceType: 'Specific Funder Meeting Preparation',
    imageUrl: DonorSimulationAvatar,
    date: '23 Sept, 24 | 1:30pm'
  },
  {
    title: 'Funder Meeting Follow-up',
    donorType: 'Individual Donor',
    practiceType: 'Follow-up Discussion',
    imageUrl: DonorSimulationAvatar,
    date: '23 Sept, 24 | 1:30pm'
  },
  {
    title: 'Funder Meeting Follow-up',
    donorType: 'Individual Donor',
    practiceType: 'Follow-up Discussion',
    imageUrl: DonorSimulationAvatar,
    date: '23 Sept, 24 | 1:30pm'
  },
  {
    title: 'Funder Meeting Follow-up',
    donorType: 'Individual Donor',
    practiceType: 'Follow-up Discussion',
    imageUrl: DonorSimulationAvatar,
    date: '23 Sept, 24 | 1:30pm'
  }
];

export const practices = [
  {
    key: 'custom-donor-meeting',
    title: 'Prep for a Donor Meeting',
    image: goal,
    backgroundClass: 'bg-primary',
    url: '/simulation'
  },
  {
    key: 'ask-coach-tivy',
    title: 'Coaching with Tivy',
    image: chatbot,
    backgroundClass: 'bg-brandSecondaryBlue',
    url: '/coaching'
  },
  {
    key: 'donor-scenarios',
    title: 'Practice Scenarios',
    image: scenarios,
    backgroundClass: 'bg-brandPrimaryGreen',
    url: '/donor-scenarios'
  },
  {
    key: 'ai-email-assistant',
    title: 'Craft a Donor Message',
    image: aiEmailAssistant,
    backgroundClass: 'bg-buttonOrange',
    url: '/ai-email-assistant'
  }
];

export const podcasts = [
  {
    id: 202,
    title: 'Leadership Transitions and Personal Mission',
    guest: 'Amber Melanie Smith',
    image: card
  },
  {
    id: 201,
    title: 'Financial Transparency and Building Impactful Relationships in Fundraising',
    guest: 'Lisa Hamilton Smith',
    image: card2
  },
  {
    id: 200,
    title: 'Empowerment, Stress Management, and Sustainable Leadership',
    guest: 'Amanda Gulino',
    image: card3
  }
];

export const hintListIndividual = [
  'Tailor to their personal passions and values.',
  'Build a genuine personal connection.',
  'Share stories of tangible emotional impact.',
  'Highlight their role in creating change.',
  'Acknowledge their motivations and emotions.',
  'Foster a sense of community and belonging.',
  'Express sincere gratitude and recognition.',
  'Show ongoing impact to deepen relationships.'
];

export const hintListCorporate = [
  'Align your mission with their business goals.',
  'Emphasize corporate social responsibility alignment.',
  'Show how partnership increases brand reputation.',
  'Propose employee engagement opportunities.',
  'Present data-driven outcomes and ROI.',
  'Frame partnership as mutually beneficial.',
  'Offer visibility through sponsorship opportunities.',
  'Highlight opportunities for long-term collaboration.'
];
export const hintListFoundation = [
  'Align project outcomes with foundation goals.',
  'Provide clear, measurable impact data.',
  'Emphasize your organization’s mission and strategy.',
  'Show commitment to transparency and accountability.',
  'Highlight long-term sustainability and outcomes.',
  'Explain how your work addresses systemic issues.',
  'Showcase collaborative potential with other grantees.',
  'Build trust through empathy and understanding.'
];

export const subHeadingInd = [
  'Wonderful! Let’s get you ready for your meeting with this individual donor. First, we need to gather a few details to tailor your practice session and make it as relevant as possible for your upcoming meeting. Don’t worry about anything you don’t know the answer to, just put in any appropriate details you have!'
];

export const subHeadingStep3 = [
  'Final step! If you would like to set up donor personality traits, use the sliders below. Use Additional Information to let us know more about the donor to help create a more realistic meeting experience. Please do not add sensitive donor data.'
];

export const subCorporateInd = [
  "Great! Let's get you prepared for your upcoming meeting with this corporate partner. To tailor your practice session and make it as impactful as possible, we'll need a few details. Don’t worry about anything you don’t know the answer to, just put in any details you have!"
];

export const subFundationInd = [
  "Great! Let’s make sure you’re fully prepared for your upcoming meeting with this foundation funder. To tailor your practice session and maximize its relevance, we'll gather a few key details. Don’t worry about anything you don’t know the answer to, just put in any details you have!"
];

export const generalGoalMeeting = [
  {
    key: 'Build or Deepen Engagement',
    value: ' Build or Deepen Engagement'
  },
  {
    key: 'Solicit a Donation',
    value: 'Solicit a Donation'
  },
  {
    key: 'Secure a Pledge or Commitment',
    value: 'Secure a Pledge or Commitment'
  },

  {
    key: 'Express Gratitude and Provide Impact Updates',
    value: ' Express Gratitude and Provide Impact Updates'
  },
  {
    key: 'Discuss Planned Giving or Legacy Opportunities',
    value: ' Discuss Planned Giving or Legacy Opportunities'
  },
  {
    key: 'Invite to Event  or Further Involvement',
    value: 'Invite to Event  or Further Involvement'
  },

  {
    key: 'Re-engage a Lapsed Donor',
    value: ' Re-engage a Lapsed Donor'
  },
  {
    key: 'Gain Feedback or Input',
    value: 'Gain Feedback or Input'
  },

  {
    key: 'Transition to Advocacy/Leadership Role',
    value: 'Transition to Advocacy/Leadership Role'
  }
];

export const donorsData = [
  {
    name: 'Robert',
    age: 60,
    gender: 'Male',
    image: '/images/Robert-Whitman.png',
    audio: '/audio/Chris.mp3',
    audioId: 'iP95p4xoKVk53GoZ742B',
    audioType: '11labs'
  },
  {
    name: 'Raj',
    age: 62,
    gender: 'Male',
    image: '/images/Raj-Singh.png',
    audio: '/audio/Arjun.mp3',
    audioId: 'eyVoIoi3vo6sJoHOKgAc',
    audioType: '11labs'
  },
  {
    name: 'Angela',
    age: 42,
    gender: 'Female',
    image: '/images/Angela-Hernandez.png',
    audio: '/audio/Angela.mp3',
    audioId: 'PT4nqlKZfc06VW1BuClj',
    audioType: '11labs'
  },
  {
    name: 'Mateo',
    age: 34,
    gender: 'Male',
    image: '/images/Mateo-Williams.png',
    audio: '/audio/Antoni.mp3',
    audioId: 'ErXwobaYiN019PkySvjV',
    audioType: '11labs'
  },
  {
    name: 'Miriam',
    age: 65,
    gender: 'Female',
    image: '/images/Miriam-Jackson.png',
    audio: '/audio/Conny.mp3',
    audioId: 'uvysWDLbKpA4XvpD3GI6',
    audioType: '11labs'
  },
  {
    name: 'Jordan',
    age: 34,
    gender: 'Non-binary',
    image: '/images/Jordan-Malley.png',
    audio: '/audio/Rachel.mp3',
    audioId: '21m00Tcm4TlvDq8ikWAM',
    audioType: '11labs'
  }
];

export enum FeedbackPageTabs {
  TRANSCRIPT = 'transcript',
  FEEDBACK = 'feedback'
}

export const coachingData = {
  name: 'Tivy',
  image: '/images/logo.svg',
  audioId: 'g6xIsTj2HwM6VR4iXFCw',
  audioType: '11labs'
};

export const ageRanges = [
  { label: '18-25', value: '18-25' },
  { label: '26-40', value: '26-40' },
  { label: '41-56', value: '41-56' },
  { label: '57-75', value: '57-75' },
  { label: '76+', value: '76+' }
];

export const genderList = [
  { label: 'Male', value: GendersEnum.MALE },
  { label: 'Female', value: GendersEnum.FEMALE },
  { label: 'Non-Binary', value: GendersEnum.NON_BINARY }
];

export enum VoiceIds {
  MALE = 'MWhyqJHbZJaOK1qPaAaN',
  FEMALE = 'jBzLvP03992lMFEkj2kJ',
  NONBINARY = '807MhexSYBuyUN7pI4wT'
}

export const defaultDonorImage = '/images/logo.svg';

export const dashboardNotionURL = 'https://wary-passbook-1b5.notion.site/15f80df9a2e680ad9c9ff3991e747b81';

export const ratingFaces = [
  { label: 'confused-face', face: ConfusedFace, rating: 1 },
  { label: 'neutral-face', face: NeutralFace, rating: 2 },
  { label: 'smiling-face', face: SmilingFace, rating: 3 },
  { label: 'hugging-face', face: HuggingFace, rating: 4 },
  { label: 'star-face', face: StarFace, rating: 5 }
];

export const scoreLabels = [
  { score: 100, label: 'Tivy-Level Talent', color: 'green' },
  { score: 75, label: 'Strong Reach', color: 'blue' },
  { score: 50, label: 'Getting a Grip', color: 'yellow' },
  { score: 25, label: 'Tentative Tentacle', color: 'red' },
  { score: 0, label: 'Just a Ripple', color: 'neutral' }
];

export const navigationConfirmRoutes = ['/donors-chat', '/simulation', '/coaching'];

export const TOKEN_COOKIE_NAME = 'accessToken';
export const INTERCOM_TOKEN_COOKIE_NAME = 'intercomToken';

export const WHITELISTED_PATHS = new Set([
  '/api/users/signin',
  '/api/users/send-one-time-password',
  '/api/users/verify-one-time-password',
  '/api/users/signup',
  '/api/users/request-reset-password',
  '/api/users/reset-password',
  '/api/organizations/invitations'
]);

export const SENTIMENT_CHART_STEPS = ['Declined', 'Stayed the same', 'Improved'];

export const AVATAR_CONVERSATION_IMAGES = {
  'Donor': '/images/icon-avatar-individual-donor.png',
  'Scenario': '/images/icon-avatar-practice-scenario.png',
  'Coaching': '/images/icon-avatar-coaching.png'
} as const;

export const PRACTICE_TYPE_META = {
  Coaching: {
    label: 'Coaching Session',
    colors: { fromColor: '#60A5FA', toColor: '#3B82F6' }
  },
  Scenario: {
    label: 'Practice Scenario',
    colors: { fromColor: '#FF8A65', toColor: '#FE6840' }
  },
  Donor: {
    label: 'Custom Donor Simulation',
    colors: { fromColor: '#34D399', toColor: '#0fa56b' }
  },
  FeedbackCoaching: {
    label: 'Feedback Coaching',
    colors: { fromColor: '#FCD34D', toColor: '#FBBF24' }
  }
};
